import { render, staticRenderFns } from "./ChampionshipBracket.vue?vue&type=template&id=4456918c&scoped=true"
import script from "./ChampionshipBracket.vue?vue&type=script&lang=js"
export * from "./ChampionshipBracket.vue?vue&type=script&lang=js"
import style0 from "./ChampionshipBracket.vue?vue&type=style&index=0&id=4456918c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4456918c",
  null
  
)

export default component.exports